import React, { useRef, useEffect } from 'react';

import * as input from 'web/components/common/modal/common/input';
import Logo from 'web/components/common/modal/common/Logo';
import CloseBtn from 'web/components/common/modal/common/CloseBtn';

import BackBtn from 'web/components/common/modal/common/BackBtn';
import ScriptBox from 'web/components/common/modal/common/ScriptBox';
import DuplicateData from 'web/components/common/modal/DuplicateData';

import classNames from 'classnames/bind';
import styles from './VertifyPhone.scss';
const cx = classNames.bind(styles);

const VertifyPhone = ({
  modal = {},
  text = {},
  active = false,

  type = 'default',
  phone = '',
  phoneCode = '',
  verification = {},
  error = {},
  falseList = [],
  overlapCheck = true,

  handleChange,
  handleBlur,
  handleSubmit,
  handlePopup,
  handleBack,
  handleInit,
  handleDrop,

  sendVerificationNumber,
  getMyPhoneNumber,
}) => {
  // console.log({ modal });
  // const { phone } = verification;

  const phoneCodeEl = useRef(null);

  const handlePhoneCodeRequest = async e => {
    if (e) e.preventDefault();
    await sendVerificationNumber(e);
    // console.log(`############################################################`);
  };

  useEffect(() => {
    // console.log(`@@@@@@@@@@@@`, verification.phone);

    if (phoneCodeEl.current) {
      phoneCodeEl.current.focus();
    }
  }, [verification.phone]);

  // console.log({ verification, type });

  return (
    <div
      className={cx('VertifyPhone', 'vertify-phone')}
      onClick={e => e.stopPropagation()}
    >
      {/* 핸드폰 인증 */}
      <Logo title={text.title ? text.title : `휴대전화번호 인증`} />
      <form
        onSubmit={
          verification.phone || !(phone.length >= 10 && phone.length <= 11)
            ? e => {
                e.preventDefault();
              }
            : handlePhoneCodeRequest
        }
      >
        <input.Text
          key={`${type}-phone`}
          type={'text'}
          name={'phone'}
          value={phone}
          validation={verification.phone}
          error={error.phone && error.phone.message}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={`휴대전화번호를 입력해주세요.`}
          kindType={type}
        />

        <div
          className="agree-guide"
          style={{
            maxWidth: '190px',
            marginTop: '-8px',
            marginBottom: '10px',
            paddingLeft: '5px',
            // letterSpacing: '-1px',
          }}
        >
          장시간 인증번호 문자가 오지 않는 경우 <br />
          ‘인증 요청’ 버튼을 다시 한번 눌러주세요.
        </div>

        <button
          tabIndex="0"
          type="submit"
          className={
            phone.length >= 10 && phone.length <= 11 ? [] : ['disabled']
          }
          style={
            verification.phone || !(phone.length >= 10 && phone.length <= 11)
              ? {
                  float: 'right',
                  position: 'relative',
                  right: '0px',
                  top: '-5px',
                  fontSize: '11px',
                  lineHeight: '1.82',
                  color: '#fff',
                  backgroundColor: '#d5d5d5',
                  borderRadius: '5px',
                  padding: '2px 8px',
                  cursor: 'disable',
                }
              : {
                  float: 'right',
                  position: 'relative',
                  right: '0px',
                  top: '-5px',
                  fontSize: '11px',
                  lineHeight: '1.82',
                  color: '#fff',
                  backgroundColor: '#3b3283',
                  borderRadius: '5px',
                  padding: '2px 8px',
                  cursor: 'pointer',
                }
          }
        >
          인증 요청
        </button>
      </form>

      <form
        onSubmit={e => {
          e.preventDefault();
          // handleSubmit(e);

          text.submit &&
          verification.phone &&
          verification.phoneCode &&
          modal.data.type === 'dropOut'
            ? handleDrop(e)
            : text.submit && verification.phone && verification.phoneCode
            ? getMyPhoneNumber(e)
            : handleSubmit(e);
        }}
        autoComplete={`off`}
      >
        {verification.phone ? (
          <>
            <input.Text
              key={`${type}-phoneCode`}
              type={'text'}
              name={'phoneCode'}
              value={phoneCode}
              refObj={phoneCodeEl}
              validation={verification.phoneCode}
              error={
                modal.data &&
                modal.data.type === 'dropOut' &&
                error.phoneCode.code === 200
                  ? ''
                  : error.phoneCode && error.phoneCode.message
              }
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder={`인증번호를 입력해주세요.`}
              autoComplete={`off`}
              kindType={type}
            />
          </>
        ) : null}

        <div className="buttons">
          <input.Button
            tabIndex="0"
            type="submit"
            className={verification.phone ? [] : ['disabled']}
            disabled={verification.phone ? false : true}
            style={{
              position: 'absolute',
              left: '20px',
              bottom: '45px',
              width: `calc(100% - 40px)`,
            }}
          >
            {text.submit &&
            verification.phone &&
            verification.phoneCode &&
            modal.data &&
            modal.data.type === 'dropOut'
              ? '탈퇴하기'
              : text.submit && verification.phone && verification.phoneCode
              ? '변경하기'
              : text.submit
              ? text.submit
              : '가입 완료'}
          </input.Button>

          {/* {type === 'vertify' &&
            verification.phoneCode &&
            verification.phoneCode.email === '' && (
              <div>
                <p style={{ color: '#c70039', fontSize: '11px' }}>
                  가입된 휴대폰 번호가 아닙니다.
                </p>
              </div>
            )} */}
        </div>
      </form>

      {modal.data && !modal.data.type ? (
        <BackBtn className={['btn-back']} onClick={() => handleBack()} />
      ) : null}

      <CloseBtn onClick={handlePopup.close} className={['btn-close']} />

      {modal.type === 'VertifyPhone' &&
      verification.phone &&
      verification.phoneCode &&
      modal.data.type !== 'dropOut' &&
      error.phoneCode.email ? (
        <ScriptBox
          className={[
            'phoneCodeOverlap',
            `active-${verification.phoneCode ? true : false}`,
          ]}
        >
          <DuplicateData
            guide={`입력하신 휴대전화번호와 \n연동된 계정이 있습니다.`}
            email={error.phoneCode.email}
            buttons={[
              {
                idx: 1,
                name: '기존 계정으로 로그인',
                type: 'button',
                onClick: () => {
                  handlePopup.login(error.phoneCode.email);
                },
              },
            ]}
            links={[
              {
                idx: 1,
                type: 'button',
                onClick: handlePopup.findPassword,
                title: `비밀번호를 잊어버리셨나요?`,
              },
            ]}
            finalButton={
              !falseList.length
                ? {
                    msg: `가입한 적 없는 이메일이라면`,
                    onClick: e => {
                      // console.log('무시하고 번호 가져오기');
                      getMyPhoneNumber(e);
                      // handlePopup.close();
                    }, ///handleSubmit(e, { type: 'Join' }),
                    name: text.join ? text.join : `무시하고 번호 가져오기`,
                  }
                : {}
            }
            handleBack={handleInit}
            handleClose={handlePopup.close}
          />
        </ScriptBox>
      ) : null}

      {modal.type === 'FindPassword' &&
      verification.phone &&
      verification.phoneCode ? (
        <ScriptBox
          className={[
            'phoneCodeOverlap',
            `active-${verification.phoneCode ? true : false}`,
          ]}
        >
          <DuplicateData
            guide={`임시 비밀번호를 \n핸드폰으로 '발급' 하였습니다.`}
            buttons={[
              {
                idx: 1,
                name: '기존 계정으로 로그인',
                type: 'button',
                onClick: () => {
                  handlePopup.login();
                },
              },
            ]}
            links={[
              {
                idx: 1,
                type: 'button',
                onClick: handlePopup.findEmail,
                title: `이메일을 잊어버리셨나요?`,
              },
            ]}
            finalButton={
              !falseList.length
                ? {
                    msg: ``,
                    onClick: e => handleSubmit(e, { type: 'Join' }),
                    name: text.join ? text.join : `새로 가입하기`,
                  }
                : {}
            }
            handleBack={handleInit}
            handleClose={handlePopup.close}
          />
        </ScriptBox>
      ) : null}

      {(modal.type === 'Join' || modal.type === 'FindEmail') &&
      error.phoneCode &&
      error.phoneCode.email ? (
        <ScriptBox
          className={[
            'phoneCodeOverlap',
            `active-${error.phoneCode.email ? true : false}`,
          ]}
        >
          <DuplicateData
            guide={`입력하신 휴대전화번호와 \n연결된 계정이 있습니다.`}
            email={error.phoneCode.email}
            buttons={[
              {
                idx: 1,
                name: '기존 계정으로 로그인',
                type: 'button',
                onClick: () => {
                  handlePopup.login(error.phoneCode.email);
                },
              },
            ]}
            links={[
              {
                idx: 1,
                type: 'button',
                onClick: handlePopup.findPassword,
                title: `비밀번호를 잊어버리셨나요?`,
              },
            ]}
            finalButton={
              !falseList.length
                ? {
                    msg: `가입한 적 없는 이메일이라면`,
                    onClick: e => handleSubmit(e, { type: 'Join' }),
                    name: text.join ? text.join : `무시하고 새로 가입하기`,
                  }
                : {}
            }
            handleBack={handleInit}
            handleClose={handlePopup.close}
          />
        </ScriptBox>
      ) : null}
    </div>
  );
};

export default VertifyPhone;
